
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","width":"682.667","height":"682.667","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M118.4 22c-21.9 3.2-41.1 19.6-47.6 40.3l-2.3 7.2v381l2.3 5.8c3.1 7.6 12.2 17.4 19.6 21 10.4 5.1 22.1 5.9 32.4 2.3 2.3-.8 28.2-16.5 57.5-34.8 29.2-18.3 55.9-34.4 59.2-35.7 5.1-2.2 7.5-2.6 16.5-2.6s11.4.4 16.5 2.6c3.3 1.4 30 17.4 59.2 35.7 29.2 18.3 55.1 33.9 57.5 34.8 22 7.8 46.5-4.9 53.2-27.5 1.4-4.9 1.6-23.5 1.6-192.1 0-182.7 0-186.8-2-194.4-4.9-19.4-19-34.5-38.5-41.3l-8-2.8-136-.1c-74.8-.1-138.3.2-141.1.6zm232.5 108.6c9 4.5 13.4 14 11 23.8-1.6 6.7-8.5 13.8-15.1 15.4-6.7 1.7-174.9 1.7-181.6 0-6.6-1.6-13.5-8.7-15.1-15.4-2.4-9.8 2-19.3 11-23.8l5.3-2.6h179.2l5.3 2.6zm0 89c12.7 6.4 15.5 21.9 5.9 32.8-6.9 7.9-2.4 7.6-100.5 7.6-62.9 0-87.7-.3-91.1-1.2-6.6-1.6-13.5-8.7-15.1-15.4-2.4-9.8 2-19.3 11-23.8l5.3-2.6h179.2l5.3 2.6z"}})])
          )
        }
      }
    